<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>Energy Use</h1>
    </div>
    <div class="page-content">
      <div class="row">

      </div>
    </div>
  </div>
</div>
